import Skeleton from "../../components/Skeleton";
import useCurrentUserAccount from "../../hooks/data/queries/useCurrentUserAccount";
import { AccountHolder } from "../../services/accountService";
import Panel from "./Panel";

type Props = {
  accountConfigData: AccountHolder | undefined;
  isLoading: boolean;
};

function AdyenConfigurations({
  accountConfigData,
  isLoading,
}: Props): JSX.Element {
  const { data: currentUserAccount } = useCurrentUserAccount();

  const getAdyenAccountHolderDetailUrl = (
    accountHolderId: string | undefined
  ) =>
    process.env.REACT_APP_ADYEN_ACCOUNT_HOLDER_DETAIL_URL_TEMPLATE?.replace(
      "{AccountHolderId}",
      accountHolderId ?? ""
    ) ?? "";

  return (
    <Panel className="col-span-7">
      <Panel.Header title="Configurations" />
      <Panel.Content>
        <div className="grid grid-cols-2 grid-rows-6 gap-x-2 gap-y-2">
          <div className="font-medium">Payment Processing Status</div>
          <div className="truncate">
            {isLoading ? (
              <Skeleton />
            ) : accountConfigData?.paymentProcessingState ? (
              "Enabled"
            ) : (
              "Disabled"
            )}
          </div>
          <div className="font-medium">Merchant Account</div>
          <div className="truncate">
            {isLoading ? <Skeleton /> : accountConfigData?.adyenMerchantAccount}
          </div>

          <div className="font-medium">Payout Status</div>
          <div className="truncate">
            {isLoading ? (
              <Skeleton />
            ) : accountConfigData?.payoutState ? (
              "Enabled"
            ) : (
              "Disabled"
            )}
          </div>

          <div className="font-medium">Account Holder</div>
          <div className="truncate">
            {isLoading ? (
              <Skeleton />
            ) : currentUserAccount?.type === "CSR" ? (
              <a
                href={getAdyenAccountHolderDetailUrl(
                  accountConfigData?.balancePlatformAccountHolderId
                )}
                title="View Account Holder in Adyen Console"
                target="adyenSite"
                className="text-primary underline"
              >
                {accountConfigData?.adyenAccountHolderCode}
              </a>
            ) : (
              <>{accountConfigData?.adyenAccountHolderCode}</>
            )}
          </div>

          <div className="font-medium">Entity Type</div>
          <div className="truncate">
            {isLoading ? <Skeleton /> : accountConfigData?.legalEntityType}
          </div>

          <div className="font-medium">Account Holder Status</div>
          <div className="truncate">
            {isLoading ? <Skeleton /> : accountConfigData?.adyenStatus}
          </div>

          <div className="font-medium">Payout Schedule</div>
          <div className="truncate">
            {isLoading ? (
              <Skeleton />
            ) : (
              accountConfigData?.adyenPayoutSchedule ?? "Active"
            )}
          </div>
        </div>
      </Panel.Content>
    </Panel>
  );
}

export default AdyenConfigurations;
